export default __webpack_public_path__ + "static/media/home_icon.1fd35452.svg";